import clsx from 'clsx'
import { EyeIcon, EyeSlashIcon } from '@heroicons/react/24/outline'

const formClasses =
	'block w-full appearance-none rounded-md border border-gray-200 bg-gray-50 px-3 py-2 text-gray-900 placeholder-gray-400 focus:border-blue-500 focus:bg-white focus:outline-none focus:ring-blue-500 sm:text-sm'

function Label({ id, children }) {
	return (
		<label
			htmlFor={id}
			className="mb-0 block text-sm font-medium text-gray-700"
		>
			{children}
		</label>
	)
}

export function TextField({
	id,
	label,
	type = 'text',
	className = '',
	onChange,
	...props
}) {
	return (
		<div className={className}>
			{label && <Label id={id}>{label}</Label>}
			<input
				onChange={onChange}
				id={id}
				type={type}
				{...props}
				className={formClasses}
			/>
		</div>
	)
}

export function PasswordField({
	id,
	label,
	className = '',
	onChange,
	showPassword,
	onTogglePassword,
	...props
}) {
	return (
		<div className={className}>
			{label && <Label id={id}>{label}</Label>}
			<div className="relative">
				<input
					onChange={onChange}
					id={id}
					type={showPassword ? 'text' : 'password'}
					{...props}
					className={`${formClasses} pr-10`}
				/>
				<button
					type="button"
					onClick={onTogglePassword}
					className="absolute inset-y-0 right-0 flex items-center pr-3 text-gray-400 hover:text-gray-600"
				>
					{showPassword ? (
						<EyeSlashIcon className="h-5 w-5" />
					) : (
						<EyeIcon className="h-5 w-5" />
					)}
				</button>
			</div>
		</div>
	)
}

export function SelectField({ id, label, className = '', ...props }) {
	return (
		<div className={className}>
			{label && <Label id={id}>{label}</Label>}
			<select id={id} {...props} className={clsx(formClasses, 'pr-8')} />
		</div>
	)
}
